import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

export type MathSingleArgFns = {
  [K in keyof Math as Parameters<Extract<Math[K], () => number>> extends [number]
    ? Math[K] extends (arg: number) => number
      ? K
      : never
    : never]: Math[K];
};

@Pipe({
  standalone: true,
  name: 'math',
})
export class MathPipe implements PipeTransform {
  public transform<T extends keyof MathSingleArgFns>(value: number, transformName: T): number {
    return Math[transformName](value);
  }
}
